import { productBrandStyles as styles } from "@insite/content-library/Components/ProductBrand";
import { css } from "styled-components";

styles.nameLink = {
    ...styles.nameLink,
    css: css`
        width: auto;
    `,
};
